import React, { useEffect, useState } from "react";
// import { SketchPicker } from "react-color";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";
import Label from "../FormComponents/Label";
import ButtonActionIcon from "./ButtonActionIcon";

const ColorConfig = ({ value = [], onChange }) => {
  const [colorPairs, setColorPairs] = useState(value);
  // const [openColorPicker, setOpenColorPicker] = useState(false);

  const handleInputChange = (index, key, inputValue) => {
    const updatedPairs = JSON.parse(JSON.stringify(colorPairs));

    updatedPairs[index][key] = inputValue;
    setColorPairs(updatedPairs);
  };

  const handleAddPair = () => {
    const updatedPairs = [...colorPairs, { value: "", color: "" }];
    setColorPairs(updatedPairs);
  };

  const handleDeletePair = (index) => {
    const updatedPairs = JSON.parse(JSON.stringify(colorPairs));
    updatedPairs.splice(index, 1);
    setColorPairs(updatedPairs);
  };

  // const handleColorPicker = (index) => {
  //   if (index === openColorPicker) {
  //     setOpenColorPicker("");
  //   } else {
  //     setOpenColorPicker(index);
  //   }
  // };

  useEffect(() => {
    setColorPairs(value);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onChange(colorPairs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorPairs]);

  return (
    <div className="form_data_action_wrapper">
      <Label className="form_appuser_filter_tag">Color Config</Label>

      <div className="builder_form">
        {colorPairs?.map((pair, index) => (
          <div className={`flex_row align_center gap_1 `} key={index}>
            <Input
              placeholder="Value"
              value={pair.value}
              onChange={(e) => handleInputChange(index, "value", e.target.value)}
              containerClassName="w_75"
            />
            <div className="d_flex">
              <div className="inline_icon_action_preview input_icon_wrapper">
                <Input
                  type="color"
                  placeholder="Color"
                  value={pair.color}
                  onChange={(e) => handleInputChange(index, "color", e.target.value)}
                  containerStyle={{ backgroundColor: value ? value : "black" }}
                  inputBoxStyle={{ height: "25px", width: "25px", border: "none" }}
                />
              </div>
              <Input
                inputClassName="border_left_none outline_none"
                value={pair.color}
                onChange={(e) => handleInputChange(index, "color", e.target.value)}
                containerStyle={{ width: "78px" }}
              />
            </div>

            <ButtonActionIcon type="delete" onClick={() => handleDeletePair(index)} />
          </div>
        ))}
      </div>
      <div className="d_flex justify_end mt_2">
        <Button type="add" variant="secondary" size="small" onClick={handleAddPair}>
          +
        </Button>
      </div>
    </div>
  );
};

export default ColorConfig;
